import { render, staticRenderFns } from "./HouseList.vue?vue&type=template&id=90a35d68&scoped=true&lang=pug&"
import script from "./HouseList.vue?vue&type=script&lang=ts&"
export * from "./HouseList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a35d68",
  null
  
)

export default component.exports